<template>
    <div class="m_pad mx-auto max-w-screen-xl" role="main">
        <!-- Page Headings and breadcrumb -->
        <h1 class="pt-4 text-left text-4xl font-bold">{{ $t('Reg.OrderConfirmation.Heading') }}</h1>
        <p v-if="workflow.Approach === FilingApproach.Online" class="py-4 text-left text-xl" id="order-confirm-text" v-html="$t('Reg.OrderConfirmation.ConfirmationNumber', { orderNumber })"></p>
        <div v-if="displayBarcode === true">
            <p class="py-4 text-left text-xl" id="order-confirm-text" v-html="$t('Reg.OrderConfirmation.ConfirmationNumber', { orderNumber })"></p>
            <div class="py-4 text-left" id="barcode-image">
                <svg id="barcode"></svg>
            </div>
            <p v-if="currentWorkflow === 'Provide Proof of Publication'" class="py-4 text-left text-xl" id="proof-of-publications-text">{{ $t('Reg.OrderConfirmation.Proofs') }}</p>
        </div>
        <!-- In-person Text -->
        <div v-if="filingType === 'In-Person'">
            <p class="text-left text-xl">{{ $t('Reg.OrderConfirmation.InPerson.Copy1') }}</p>
            <p
                v-if="workflow.Type === FilingWorkflow.Standard ||
                workflow.Type === FilingWorkflow.Amendment ||
                workflow.Type === FilingWorkflow.Renewal" 
                class="py-2 text-left text-xl">
                {{ $t('Reg.OrderConfirmation.InPerson.Copy2') }}
            </p>
            <p v-else
                class="text-left text-xl">
                {{ $t('Reg.OrderConfirmation.InPerson.Copy4') }}
            </p>
            <p class="text-left text-xl" v-html="$t('Reg.OrderConfirmation.InPerson.Copy3')"></p>
            <div class="py-2 text-left text-xl">
                <a href="https://www.mytime.com/express_checkout/123989/137830" target="_blank" id="mytime" class="mytime_embedded_btn big inline-block" title="Book On MyTime"><img :src="require('@/assets/img/button_mytime_booking.jpg?v=2')" alt="MyTime Booking" title="MyTime Booking"/></a>
            </div>
        </div>
        <!-- Mail-In Text -->
        <div v-if="filingType === 'Mail-In'">
            <p
                v-if="workflow.Type === FilingWorkflow.Standard || workflow.Type === FilingWorkflow.Amendment || workflow.Type === FilingWorkflow.Renewal"
                class="text-left text-xl">
                {{ $t('Reg.OrderConfirmation.MailIn.Copy3') }}
            </p>
            <p
                v-else
                class="text-left text-xl">
                {{ $t('Reg.OrderConfirmation.MailIn.Copy2') }}
            </p>
            <p class="text-center text-xl"><strong>Business Filing and Registration</strong></p>
            <p class="text-center text-xl"><strong>P.O. Box 1208</strong></p>
            <p class="text-center text-xl"><strong>Norwalk, California 90651-1208</strong></p>
            <p class="text-left text-xl"><strong>{{ $t('Reg.OrderConfirmation.MailIn.Copy4') }}</strong></p>
            <p class="text-left text-red-800 text-xl mb-4 font-semibold">{{ $t('Reg.OrderConfirmation.MailIn.Copy5') }}</p>
            <!-- PDF Viewer -->
            <a class="text-white px-4 py-4 font-semibold darkblue text-center rounded" id="pdf-download" :href="pdfFile" download="Confirmation.pdf">Download File</a>
            <div class="mt-4" v-if="!safari">
                <div id="pdf-status"></div>
                <div id='pdf-container' class="text-center py-2">
                    <iframe id="pdf-viewer" :key="pdfKey" v-if="pdf" :src="pdf" width="100%" height="1000px"></iframe>
                </div>
            </div>          
        </div>
        <!-- Third Party Text -->
        <div v-if="filingType === 'Third Party'">
            <p class="text-left text-xl">{{ $t('Reg.OrderConfirmation.InPerson.Copy1') }}</p>
            <p v-if="workflow.Type === FilingWorkflow.Standard || 
                workflow.Type === FilingWorkflow.Amendment || 
                workflow.Type === FilingWorkflow.Renewal" class="text-left text-xl mb-4">
                {{ $t('Reg.OrderConfirmation.Copy5') }}
            </p>
            <p v-else class="text-left text-xl mb-4">{{ $t('Reg.OrderConfirmation.Copy6') }}</p>
            <p class="text-left text-xl" v-html="$t('Reg.OrderConfirmation.ThirdParty.Copy2')"></p>
            <div class="py-2 text-left text-xl">
                <a href="https://www.mytime.com/express_checkout/123989/137830" target="_blank" id="mytime" class="mytime_embedded_btn big inline-block" title="Book On MyTime"><img :src="require('@/assets/img/button_mytime_booking.jpg?v=2')" alt="MyTime Booking" title="MyTime Booking"/></a>
            </div>
            <!-- PDF Viewer -->
            <a class="text-white px-4 py-4 font-semibold darkblue text-center rounded mb-1 mt-1" id="pdf-download" :href="pdfFile" download="Confirmation.pdf">Download File</a>
            <div class="mt-4" v-if="!safari">
                <div id="pdf-status"></div>
                <div id='pdf-container' class="text-center py-2">
                    <iframe id="pdf-viewer" :key="pdfKey" v-if="pdf" :src="pdf" width="100%" height="1000px"></iframe>
                </div>
            </div>         
        </div>
        <!-- Online Filing Text -->
        <div v-if="filingType === 'Online'">
            <p class="text-left text-xl">{{ $t('Reg.OrderConfirmation.Online.Copy1') }}</p>
            <p class="text-left text-xl"><strong>{{ $t('Reg.OrderConfirmation.Online.Copy2') }}</strong></p>
            <div v-if="workflow.Type !== FilingWorkflow.Renewal">
                <p class="text-left">{{ $t('Reg.OrderConfirmation.Online.Copy3') }}
                    <br>
                    <a href="https://lavote.gov/home/county-clerk/fictitious-business-names/publication" 
                        target="_blank" id="publication" 
                        class="py-2 text-left text-xl text-indigo-700 hover:text-indigo-900">
                        https://lavote.gov/home/county-clerk/fictitious-business-names/publication
                    </a>
                </p>
            </div>
            <p class="text-left text-xl" v-html="$t('Reg.OrderConfirmation.Copy3')"></p>
        </div>
        <div v-if="ShowPricing">
            <p class="text-left text-xl mt-2"><strong>{{ $t('Reg.OrderConfirmation.Copy1') }}</strong></p>
            <p v-if="workflow.Approach !== FilingApproach.InPerson" class="text-left text-xl mt-2"><strong>{{ $t('Reg.OrderConfirmation.Copy4') }}</strong></p>
            <p v-else class="text-left text-xl">{{ $t('Reg.OrderConfirmation.Copy2') }}</p>
            <p class="text-left text-xl" v-html="$t('Reg.OrderConfirmation.Copy3')"></p>
            <div v-if="workflow.Type === FilingWorkflow.Standard">
                <p class="text-left text-xl">Original - <strong>$26.00</strong> (FOR ORIGINAL FILING WITH ONE BUSINESS NAME ON STATEMENT)</p>
                <p class="text-left text-xl"><strong>$5.00</strong> - FOR EACH ADDITIONAL BUSINESS NAME FILED ON SAME STATEMENT, DOING BUSINESS AT THE SAME LOCATION</p>
                <p class="text-left text-xl"><strong>$5.00</strong> - FOR EACH ADDITIONAL OWNER IN EXCESS OF ONE OWNER</p>
            </div>
            <div v-else-if="workflow.Type === FilingWorkflow.Amendment">
                <p class="text-left text-xl">Amendment - <strong>$26.00</strong> (CHANGES IN FACTS FROM ORIGINAL FILING - REQUIRES PUBLICATION)</p>           
                <p class="text-left text-xl"><strong>$5.00</strong> - FOR EACH ADDITIONAL BUSINESS NAME FILED ON SAME STATEMENT, DOING BUSINESS AT THE SAME LOCATION</p>
                <p class="text-left text-xl"><strong>$5.00</strong> - FOR EACH ADDITIONAL OWNER IN EXCESS OF ONE OWNER</p>
            </div>
            <div v-else-if="workflow.Type === FilingWorkflow.Renewal">
                <p class="text-left text-xl">Renewal - <strong>$26.00</strong> (NO CHANGES IN THE FACTS FROM ORIGINAL FILING)</p>
                <p class="text-left text-xl"><strong>$5.00</strong> - FOR EACH ADDITIONAL BUSINESS NAME FILED ON SAME STATEMENT, DOING BUSINESS AT THE SAME LOCATION</p>
                <p class="text-left text-xl"><strong>$5.00</strong> - FOR EACH ADDITIONAL OWNER IN EXCESS OF ONE OWNER</p>
            </div>
            <div v-else-if="workflow.Type === FilingWorkflow.Abandonment">
                <p class="text-left text-xl">Abandonment - <strong>$26.00</strong> (ABANDON BUSINESS NAMES FROM A FICTITIOUS BUSINESS NAME STATEMENT - REQUIRES PUBLICATION)</p>
            </div>
            <div v-else-if="workflow.Type === FilingWorkflow.Withdrawal">
                <p class="text-left text-xl">Withdrawal - <strong>$26.00</strong> (WITHDRAW REGISTERED OWNER(S) NAME FROM A FICTITIOUS BUSINESS NAME STATEMENT - REQUIRES PUBLICATION)</p>
            </div>
        </div>
        <div class="py-2 main-controls">
            <NavigationControls 
                :showHomeButton="true"
                :showPrintButton="true" 
                @homePage="homePage"
                @printPage="printPage"/>
        </div>
    </div>
    
</template>

<script>
import JsBarcode from 'jsbarcode';
import ClerkRepository from '../../repositories/ClerkRepository';
import { FilingApproach, FilingWorkflow } from '../../assets/constants'
import NavigationControls from '../common/NavigationControls.vue'
import { Buffer } from 'buffer'
export default {
    name: 'Confirmation Page',
    components: {
        NavigationControls
    },
    computed: {
        ShowPricing() {
            if(this.workflow.Approach === 'In-Person' || this.workflow.Approach === 'Mail-In' || this.workflow.Approach === 'Third Party') {
                return true;
            } else {
                return false;
            }
        }
    },
    data: () => ({
        orderNumber: '',
        confirmationText: '',
        businessTypeText: false,
        filingType:'',
        barcode: '',
        pdf: null,
        pdfFile: null,
        workflow: {},
        FilingApproach: FilingApproach,
        FilingWorkflow: FilingWorkflow,
        displayBarcode: true,
        safari: false
    }),
    methods: {
        printPage() {
            window.print();
        },
        homePage () {
            this.$store.dispatch('clearAllState');
            this.$router.push('/')
        },
        safariCheck () {
            const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
            const isSafari = navigator.userAgent.indexOf('Safari') > -1;
            if ( (isChrome) && (isSafari) ) { 
                this.safari = false; 
            } else {
               this.safari = true; 
            }
        }
    },
    beforeMount(){
        this.filingType = this.$store.getters.getFilingApproach;
        const businessType = this.$store.getters.getBusinessType;
        if(businessType === 'Corporation' || businessType === 'Limited Liability Company (LLC)' || businessType === 'Limited Partnership' || businessType === 'Limited Liability Partnership'){
            this.businessTypeText = true;
        }
        this.orderNumber = this.$store.getters.getOrderConfirmationNumber;
        var fbnFiling = this.$store.getters.getCurrentFiling;
        this.currentWorkflow = this.$store.getters.getWorkflow;
        this.workflow = {
            Approach: this.filingType,
            Type: this.currentWorkflow
        }
        if(this.workflow.Approach === FilingApproach.Online) {
            this.displayBarcode = false;
        }
        // Add PDF to viewer
        if (this.filingType === 'Mail-In' || this.filingType === 'Third Party') {
            if(this.filingType === 'Mail-In') {
                this.displayBarcode = false;
            }
            ClerkRepository.postPDF(fbnFiling, this.workflow, false, this.$store.getters.getFilingNumber)
            .then( response => {
                this.pdfFile = window.URL.createObjectURL(new Blob([response.data]));
                this.pdf = `data:application/pdf;base64,${Buffer.from(response.data, 'binary').toString('base64')}`;
            })
            .catch(function(error) {
                document.getElementById('pdf-status').innerHTML = '<span class="text-red-500 text-2xl font-semibold">' + this.$t('Template.ErrorHandling.PDF') + '</span>';
                console.log(`${error}`);
            });
        }
        this.safariCheck();
        window.scrollTo(0,0);
    },
    mounted(){
        if(this.displayBarcode) {
            JsBarcode('#barcode', this.orderNumber, {
                width:4,
                height:40,
                displayValue: true
            });    
        }
        
        this.$store.dispatch('clearAllState');
    }
}
</script>

<style>

    p {
        line-height: 1.8em !important;
    }

</style>
